<!--
  --
  -- 氏名入力 コンポーネント
  --
  -->
<template>
  <v-row no-gutters>
    <v-col cols="6" class="pr-2">
      <!-- 姓 -->
      <v-text-field
        label="姓"
        type="text"
        v-model="form.familyName"
        :rules="[rule.required('姓'), rule.username]"
      />
    </v-col>

    <!-- 名 -->
    <v-col cols="6" class="pl-2">
      <v-text-field
        label="名"
        type="text"
        v-model="form.givenName"
        :rules="[rule.required('名'), rule.username]"
      />
    </v-col>

    <!-- 姓(カナ) -->
    <v-col cols="6" class="pr-2">
      <v-text-field
        label="姓(カナ)"
        type="text"
        v-model="form.familyKana"
        :rules="[rule.required('姓(カナ)'), rule.userkana]"
      />
    </v-col>

    <!-- 名(カナ) -->
    <v-col cols="6" class="pl-2">
      <v-text-field
        label="名(カナ)"
        type="text"
        v-model="form.givenKana"
        :rules="[rule.required('名(カナ)'), rule.userkana]"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'CProfileName',
  props: {
    form: {
      type: Object,
      required: true
    }
  }
}
</script>
